import React from 'react';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { LoginSubmitButton } from './LoginSubmitButton';
import { LoginSigninLabel } from './SigninLabel';

export function OnboardEmailSent({ email }: { email: string }) {
  return (
    <>
      <LoginSigninLabel title={lang.emailSent} />
      <div className="col-sm-10 offset-sm-1">
        <span style={{ fontSize: 12, fontWeight: 'bold', color: '#CCC' }}>
          {lang.emailSentDescription}
        </span>
      </div>
      <div className="col-sm-10 offset-sm-1">
        <span style={{ fontSize: 12, fontWeight: 'bold', color: '#CCC' }}>
          {email}
        </span>
      </div>
      <div className="col-sm-10 offset-sm-1">
        <span style={{ fontSize: 12, fontWeight: 'bold', color: '#CCC' }}>
          {lang.emailSentInstructions}
        </span>
      </div>
      <LoginSubmitButton
        text={lang.backToLogin.toUpperCase()}
        onClick={() => window.location.assign('/login')}
      />
    </>
  );
}

const lang = LocalizedStrings({
  en: {
    emailSent: 'Email sent!',
    emailSentDescription: 'An email has been sent to:',
    emailSentInstructions: 'Please check your inbox and follow the instructions to set up your account',
    backToLogin: 'Back to the login page',
  },
});
